export const routes = [
  {
    label: 'Services',
    href: '/services',
  },
  {
    label: 'AI Consultation',
    href: '/custom-ai',
  },
  {
    label: 'Products',
    href: '/products',
  },
  {
    label: 'Careers',
    href: '/careers',
  },
  {
    label: 'Blog',
    href: '/blogs',
  },
  {
    label: 'Partner',
    href: '/services/partner-aws',
  },
  {
    label: 'Contact',
    href: '/contact',
  },
]
